import { ComponentType, FC } from 'react';
import { FundInvestmentsProvider } from 'providers';

const withFundInvestmentsProvider = <P extends object>(Component: ComponentType<P>): FC<P> => {
  const WrappedWithProvider: FC<P> = props => (
    <FundInvestmentsProvider>
      <Component {...props} />
    </FundInvestmentsProvider>
  );

  WrappedWithProvider.displayName = `withFundInvestmentsProvider(${Component.displayName || Component.name})`;

  return WrappedWithProvider;
};

export default withFundInvestmentsProvider;
